import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Notistack } from '@/app/shared/components/Notistack';
import { getError } from '@/app/shared/utils/helpers';
import logo from '@/assets/images/hello-refi-logo.svg';
import { loginRequest } from './authConfig';

const Container = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
}));

const Content = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(5),
  borderRadius: theme.spacing(1),
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  maxWidth: 415,
  width: '100%',
  textAlign: 'center',
}));

const LogoSection = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
  textAlign: 'center',
  img: {
    width: '18rem',
    height: 'auto',
  },
  '@media (max-width: 427px)': {
    img: {
      width: '5rem',
      height: 'auto',
    },
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginTop: theme.spacing(2),
  display: 'block',
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

const AuthButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  borderRadius: 25,
  fontSize: 16,
  fontWeight: 600,
}));

function Auth() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      if (!sessionStorage.getItem('postLoginRedirect')) {
        sessionStorage.setItem('postLoginRedirect', location.search);
      }
      sessionStorage.removeItem('auth_redirect_in_progress');
      navigate(`/${location.search}`);
    }
  }, [isAuthenticated, accounts]);

  const handleLogin = () => {
    if (!instance) return Notistack.generalError(getError('MSAL not initialized'));

    instance.loginRedirect({
      ...loginRequest,
      state: sessionStorage.getItem('postLoginRedirect') ||
        window.location.pathname +
        window.location.search,
    }).catch((error) => {
      console.error(error?.message || 'Login failed');
    });
  };

  const handleSignup = () => {
    if (!instance) return Notistack.generalError(getError('MSAL not initialized'));

    instance.loginRedirect({
      ...loginRequest,
      prompt: 'create',
    }).catch((error) => {
      console.error(error?.message || 'Signup failed');
    });
  };

  return (
    <Container>
      <Content>
        <LogoSection>
          <img
            src={logo}
            alt="logo"
          />
          <Title variant="h1">Customer Portal</Title>
        </LogoSection>

        <ButtonContainer>
          <AuthButton
            variant="contained"
            color="primary"
            onClick={handleLogin}
          >
            Login
          </AuthButton>

          <AuthButton
            variant="contained"
            color="primary"
            onClick={handleSignup}
          >
            Sign Up
          </AuthButton>
        </ButtonContainer>
      </Content>
    </Container>
  );
}

export default Auth;
